import styles from './style.sass'
import ReactDOM from 'react-dom/client'
import App from './components/App'

const root = ReactDOM.createRoot(document.querySelector('#root'))
const step1 = 'npm i three@0.148 @react-three/fiber@8.9'

root.render(
  <>
    <App />
  </>
)
